/** Liest `sub` (= auth.uid) aus dem JWT-Payload. Kein Verify — nur Claim-Auslesen. */
export function decodeJwtSub(token) {
    const parts = token.split('.');
    if (parts.length < 2)
        return null;
    try {
        const b64 = parts[1].replace(/-/g, '+').replace(/_/g, '/');
        const pad = b64.length % 4 === 0 ? '' : '='.repeat(4 - (b64.length % 4));
        const json = JSON.parse(atob(b64 + pad));
        return json.sub ?? null;
    }
    catch {
        return null;
    }
}
/**
 * Merged Registry-Reihenfolge mit gespeicherten Prefs zu zwei sortierten Bloecken.
 * Pure Funktion (keine I/O). Marktplaetze ohne Pref-Zeile erben Registry-Default
 * (kein Favorit, Registry-Index als sort_index).
 */
export function mergePrefs(registry, prefs) {
    const prefMap = new Map(prefs.map((p) => [p.marketplaceId, p]));
    const decorated = registry.map((entry, idx) => {
        const pref = prefMap.get(entry.id);
        return {
            id: entry.id,
            isFavorite: pref?.isFavorite ?? false,
            sortIndex: pref?.sortIndex ?? idx,
            registryIndex: idx,
        };
    });
    const byOrder = (a, b) => a.sortIndex - b.sortIndex || a.registryIndex - b.registryIndex;
    return {
        favorites: decorated.filter((d) => d.isFavorite).sort(byOrder).map((d) => d.id),
        others: decorated.filter((d) => !d.isFavorite).sort(byOrder).map((d) => d.id),
    };
}
/** Laedt alle Prefs des aktuellen Users (RLS filtert User + aktiven Tenant). Bei Fehler: []. */
export async function loadPrefs(ctx) {
    const { data, error } = await ctx.supabase
        .schema('account')
        .from('user_marketplace_prefs')
        .select('marketplace_id, is_favorite, sort_index');
    if (error) {
        console.error('[marketplace-prefs] load failed', error.message);
        return [];
    }
    return (data ?? []).map((r) => ({
        marketplaceId: r.marketplace_id,
        isFavorite: r.is_favorite,
        sortIndex: r.sort_index,
    }));
}
/**
 * Schreibt die komplette sichtbare Reihenfolge neu (Batch-Upsert).
 * sort_index laeuft global: erst Favoriten (0..k-1), dann Rest (k..n-1) —
 * passt zur Filter+Sort-Logik in mergePrefs.
 */
export async function savePrefs(ctx, view) {
    const userId = decodeJwtSub(ctx.session.token);
    if (!userId) {
        console.error('[marketplace-prefs] save skipped — kein sub im Token');
        return;
    }
    const ordered = [
        ...view.favorites.map((id) => ({ id, fav: true })),
        ...view.others.map((id) => ({ id, fav: false })),
    ];
    if (ordered.length === 0)
        return;
    const rows = ordered.map((o, idx) => ({
        user_id: userId,
        tenant_id: ctx.session.tenantId,
        marketplace_id: o.id,
        is_favorite: o.fav,
        sort_index: idx,
    }));
    const { error } = await ctx.supabase
        .schema('account')
        .from('user_marketplace_prefs')
        .upsert(rows, { onConflict: 'user_id,tenant_id,marketplace_id' });
    if (error)
        console.error('[marketplace-prefs] save failed', error.message);
}
//# sourceMappingURL=marketplace-prefs.js.map